module.exports = __webpack_public_path__ + "static/media/SpaceGrotesk-SemiBold.18fb4312.woff";